import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { WhyChooseUs } from "@/components/site/WhyChooseUs";
import { Gallery } from "@/components/site/Gallery";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="relative min-h-screen bg-[#0A0A0A] font-body text-[#FAFAFA]">
        <div className="noise-overlay" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Services />
          <WhyChooseUs />
          <Gallery />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </ReactLenis>
  );
}

export default App;
